import React from 'react';
// Images
import GalleryImage2 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-adult-baby.webp';
import GalleryImage1 from '../../assets/images/smallGallery/miss-dominatrixa-elite-dominatrix-with-whip-small.webp';
// Constants
import {
  CompanyName,
  QuestionaireUrl,
  LocationCountry,
  ServiceArea,
} from '../../utils/Constants';
// Components
import CallToActionOne from '../cta/CallToActionOne';

function AboutPageMainContainer() {
  return (
    <main
      role='main'
      className='pt-24 lg:pt-32 mb-20 full_shadow_black_invert'
    >
      {/* About Section */}
      <section className='grid mb-20'>
        <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 md:px-20 lg:px-10 xl:gap-x-10 '>
          {/* Image */}
          <div className='my-auto'>
            <img
              src={GalleryImage1}
              alt={`${CompanyName} neon diamond logo`}
              className='mx-auto object-cover md:max-h-[60vh] rounded shadow-cardShadow shadow-colour4/80 dark:shadow-colour4/80 '
              loading='lazy'
            />
          </div>

          {/* Article */}
          <article className='grid gap-4 pt-6'>
            {/* Header */}
            <section className='grid lg:grid-cols-reg w-full lg:gap-x-6 pb-2'>
              <div className='grid items-center text-center '>
                <h3 className='text-3xl font-titleFont tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 lg:border-none'>
                  My Personality
                </h3>
              </div>
              <div className='items-center hidden lg:grid'>
                <div
                  className='h-[2px] -mt-1 bg-colour3 dark:bg-colour3'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            {/* Main article */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                <strong className='text-colour3 dark:text-colour3'>
                  Sensual, sophisticated, yet undeniably strict
                </strong>{' '}
                - I am a commanding presence in the world of domination. With an
                air of refinement and an irresistible allure, I embody both
                elegance and a darkly seductive edge. My control is effortless,
                my authority absolute, and my pleasure derives from the
                unwavering submission of those who kneel before me.
              </p>

              <p>
                Dominance is not a performance—it is an intrinsic part of my
                very being. A natural-born leader, I have been mastering the art
                of control since a young age, shaping men to my will with a mere
                glance or a whispered command. The power exchange in BDSM is
                more than an indulgence; it is my domain, where I thrive in
                bending minds and bodies to my desires.
              </p>

              <p>
                Whether you seek a{' '}
                <strong className='text-colour3 dark:text-colour3'>
                  sensory-rich fetish experience
                </strong>{' '}
                or a{' '}
                <strong className='text-colour3 dark:text-colour3'>
                  strict and immersive domination session
                </strong>
                , I tailor every encounter to my own satisfaction—while allowing
                my subjects to revel in the privilege of serving me. Playful yet
                assertive, seductive yet merciless, I deliver an experience
                unlike any other.
              </p>

              <p>
                Available throughout{' '}
                <strong className='text-colour3 dark:text-colour3'>
                  {LocationCountry} and across {ServiceArea}
                </strong>
                , I welcome only the most devoted and respectful admirers into
                my world.
                <em>Do you dare to surrender?</em>
              </p>
            </section>
          </article>
        </div>
      </section>

      {/* Dom Section */}
      <section className='grid'>
        <div className='grid lg:grid-cols-[2fr_1fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-6 sm:px-16 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Article */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid lg:grid-cols-reg text-center w-full lg:gap-x-6 pb-2'>
              <div className='hidden lg:grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest'>
                  Submission & Expectations
                </h3>
              </div>
              <div className='grid lg:hidden items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 lg:border-none'>
                  Submission & <br /> Expectations
                </h3>
              </div>
              <div className='hidden lg:grid items-center'>
                <div
                  className='h-[2px] -mt-1 bg-colour3 dark:bg-colour3'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            {/* Main article */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                <strong className='text-colour3 dark:text-colour3'>
                  Femdom & Findom
                </strong>
                —true submission comes at a price. Every interaction, every
                word, and every moment is on {CompanyName}’s terms. Obedience is
                expected; hesitation is not tolerated.
              </p>

              <p>
                Interested in serving? Start by proving your worth. A{' '}
                <strong className='text-colour3 dark:text-colour3'>
                  €40 tribute
                </strong>{' '}
                is required for initial contact—this is not a game, this is your
                first act of submission.
              </p>

              <p>
                <strong className='text-colour3 dark:text-colour3'>
                  Custom sessions, contracts, video calls, and real-time meets
                </strong>{' '}
                are available to those who qualify. Everything is tailored to
                her satisfaction, not yours. If you are lucky, you may
                experience what true control feels like.
              </p>

              <p>
                <em>
                  Follow instructions, pay tribute, and maybe—just maybe—you
                  will be allowed to serve.
                </em>
              </p>
            </section>
          </article>

          {/* Image */}
          <div className='my-auto pt-2'>
            <img
              src={GalleryImage2}
              alt={`${CompanyName} displaying dominance`}
              className='mx-auto object-cover md:max-h-[60vh] rounded shadow-cardShadow shadow-colour4/80'
              loading='lazy'
            />
          </div>
        </div>
      </section>

      <div className='mt-12 lg:mt-20'>
        <CallToActionOne />
      </div>
    </main>
  );
}

export default AboutPageMainContainer;
